<mat-form-field [style.width.%]="100">
    <mat-label>{{labelText }} <span *ngIf="isMandetory==1" class="field-mandatory">*</span> </mat-label>
    <mat-select #dropdownMultiSelect [(ngModel)]="selectedValues" multiple [attr.role]="null">
        <mat-select-trigger>
            {{ selectedText!=null? (selectedText.length >= 1? selectedText[0] : ""):"" }}
            <span *ngIf="selectedText.length > 1" class="MatSelect-additional-selection">
                (+{{ selectedText.length - 1 }} {{selectedText?.length === 2 ? "other" : "others" }})
            </span>
        </mat-select-trigger>
        <div class="select-all">
            <mat-checkbox [(ngModel)]="allSelected" [attr.role]="null" [ngModelOptions]="{ standalone: true }"
                (change)="toggleAllOptoinSelection()">
                Select All
            </mat-checkbox>
        </div>
        <mat-option (click)="onDropdownOptionClick()" *ngFor="let option of lstDropdownOption" [value]="option.value">
            {{ option.text }}
        </mat-option>
    </mat-select>
</mat-form-field>